// @flow
import * as React from 'react'
import { compose } from 'redux'
import { Redirect, withRouter } from 'react-router-dom'
import { auth } from 'constructor'

type Props = {
  auth: {
    data: {
      user?: Object;
    }
  };
  location: Object;
}


const withRedirect = (WrappedComponent: *) => {

  class Red extends React.Component<Props & *> {
    startRoute: string = '/contracts'
    startParentRoute: string = '/children'
    startAdminRoute: string = '/accounts'
    loginRoute: string = '/login'
    recoveryRoute: string = '/recovery'
    staffRoute: string = '/check'

    render() {
      const { auth, location, ...rest } = this.props;
      console.log("withRedirect.js render", location.pathname)
      if (auth.data.user && location.pathname === this.loginRoute) {
        if (auth.data.user.role_field === 'super_admin') { //Администратор системы
          console.log("withRedirect.js render super_admin", this.startAdminRoute)
          return (
            <Redirect to={this.startAdminRoute} />
          )
        } 

        if (auth.data.user.role_field === 'user') { //Локальный админ сада
          
          console.log("withRedirect.js render user", this.startRoute)
          return (
            <Redirect to={this.startRoute} />
          )
        } 

        if (auth.data.user.role_field === 'staff') { //Локальный сотрудник сада
          console.log("withRedirect.js render staff", this.staffRoute)
          return (
            <Redirect to={this.staffRoute} />
          )
        } 

        if (auth.data.user.role_field === 'admin') { //Сотрудники локального сада
          
          console.log("withRedirect.js render admin", this.startRoute)
          return (
            <Redirect to={this.startRoute} />
          )
        } 

        if (auth.data.user.role_field === 'trustee') { //Родители
          console.log("withRedirect.js render trustee", this.startParentRoute)
          return (
            <Redirect to={this.startParentRoute} />
          )
        } 
      }
      
      if ( auth.data.user === null &&
        location.pathname !== this.loginRoute && location.pathname !== this.recoveryRoute
      ) {
        console.log("withRedirect.js render user === null", this.loginRoute)
        return (
          <Redirect to={this.loginRoute} />
        )
      } 


      var CACHE_REDIRECT_PATH_NAME = process.env.REACT_APP_AUTH_REDIRECT_PATH_CACHE_NAME;
      var stored = localStorage.getItem(CACHE_REDIRECT_PATH_NAME);
      console.log("withRedirect.js stored", stored);
      
      let redirectPath = null;
      
      // Только если есть сохранённые данные — пытаемся извлечь путь
      if (stored) {
        try {
          const data = JSON.parse(stored);
          const nowInSeconds = Date.now() / 1000;
      
          // Проверяем, не истёк ли срок
          if (data.expires_in && nowInSeconds > data.expires_in) {
            console.log("withRedirect.js Срок действия пути истёк — удаляем");
            localStorage.removeItem(CACHE_REDIRECT_PATH_NAME);
          } else {
            redirectPath = data.pathname;
          }
        } catch (e) {
          console.error("withRedirect.js Ошибка при парсинге сохранённого пути:", e);
          localStorage.removeItem(CACHE_REDIRECT_PATH_NAME);
        }
      }
      
      // Если есть валидный redirectPath и мы не на нужной странице — редирект
      if (redirectPath) {
        console.log("withRedirect.js redirectPath:", redirectPath);
        localStorage.removeItem(CACHE_REDIRECT_PATH_NAME);
        if (location.pathname !== redirectPath) {
          console.log("withRedirect.js Redirecting to:", redirectPath);
          return <Redirect to={redirectPath} />;
        }
      }

      
      console.log("withRedirect.js render default from", location.pathname)
      return <WrappedComponent {...rest} />
    }
  }

  return compose(
    withRouter,
    auth.withAuth
  )(Red)
}

export default withRedirect
